export default {
  data() {
    return {
      sign: null,
      computedFlag: 0,
      isShowMasking: false,
      btnActive: false,
      wechatAppid: window?.ssrConfig?.routerConfig?.appid ?? '',
      iosUrl: window?.ssrConfig?.routerConfig?.scheme?.ios ?? 'superapp://h5.lifekh.com/wakeup?routepath=',
      androidUrl: window?.ssrConfig?.routerConfig?.scheme?.android ?? 'superapp://tinhnow/group?url=',
    };
  },
  computed: {
    isIOS() {
      return navigator.userAgent.toLocaleLowerCase().indexOf('mac os x') !== -1;
    },
    maskingLang() {
      return {
        one: {
          one: this.lang === 'zh' && '点击右上角的' || '点击右上角的',
          two: this.lang === 'zh' && '按钮' || '按钮'
        },
        two: {
          one: this.lang === 'zh' && '选择' || '选择',
          two: this.lang === 'zh' && '在浏览器中打开' || '在浏览器中打开'
        }
      }
    },
    logoImgs() {
      return {
        blueMenuImageSrc: require('../images/blue-menu.png'),
        blueButtonImageSrc: require('../images/blue-button.png'),
        earthImageSrc: require('../images/earth.png'),
        google: {
          src: require('../images/google-logo.png'),
          style: "width: 0.7rem;padding-top: 0.08rem;"
        },
        android: {
          src: require('../images/android-logo.png'),
          style: "width: 0.67rem;"
        },
        apple: {
          src: require('../images/apple-logo.png'),
          style: "width: 0.67rem;padding-top: 0.08rem;"
        }
      };
    },
    isDingTalk() {
      return navigator.userAgent.toLowerCase().indexOf('dingtalk') !== -1;
    },
    isQQ() {
      return navigator.userAgent.toLowerCase().indexOf('qq/') !== -1;
    },
    isWownowApp() {
      return navigator.userAgent.toLowerCase().indexOf("wownow") !== -1;
    },
    isWechat() {
      return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1;
    },
    locationQuery() {
      try {
        return this.urlQueries();
      } catch (err) {
        console.log("整理参数失败: ", err);
        return {};
      }
    },
    appRoutePath() {
      let flag = this.computedFlag
      const preFixRoute =
      (this.isIOS && this.iosUrl) || "superapp://tinhnow/group?url=";
      let routePath = encodeURIComponent(this.wxGoAppRouter)
      // 这里都是解码参数
      if (this.isWownowApp) {
        return decodeURIComponent(routePath);
      }
      return `${preFixRoute}${routePath}`;
    },
    wxGoAppRouter() {
      let flag = this.computedFlag
      let storeRoutePath =
        this.locationQuery.routePath ||
        this.locationQuery.routepath ||
        "SuperApp://GroupOn/store_detail";
      let proRoutePath = "SuperApp://GroupOn/product_detail";
      // 编码
      let routePath = ''
      if (typeof this.sign === 'object') {
        routePath =  `${storeRoutePath}`;
      } else {
        routePath =  `${proRoutePath}?ID=${this.sign}`;
      }
      return routePath
    }
  },
  watch: {
    sign(val,oldVal) {
      this.computedFlag++
    }
  },
  methods: {
    getProWxRoute(sign) {
      let proRoutePath = "SuperApp://GroupOn/product_detail";
      return `${proRoutePath}?ID=${sign}`;
    },
    setSign(sign) {
      sign ? this.sign = sign : sign = ''
    },
    urlQueries() {
      let queries = {};
      try {
        let search = window.location.search.match(/\?.*(?=\b|#)/);
        if (search) {
          search = search[0].replace(/^\?/, "");
        }
        if (search) {
          let routePathIndex = search.indexOf("SuperApp")

          search.split("&").forEach(item => {
            const param = item.split("=");
              if(param[0] == 'routePath' || param[0] == 'routepath' ){
                if(routePathIndex  !== -1) {
                  let routePathParam = search.slice(routePathIndex);
                  queries["routePath"] = decodeURIComponent(routePathParam);
                }else {
                  param[1] && (queries["routePath"] = decodeURIComponent(param[1]))
                }
              }else {
                if (param[1]) {
                  queries[param[0]] = decodeURIComponent(param[1]);
                }
              }
              
          });
        }
        const routePath = queries.routePath || queries.routepath || "";
        if (routePath?.indexOf?.("shortID") !== -1 && queries?.shortID) {
          delete queries.shortID;
        }
        if (
          typeof window?.ssrConfig?.routerConfig?.short?.params === "object" &&
          !Array.isArray(window?.ssrConfig?.routerConfig?.short?.params)
        ) {
          queries = Object.assign(
            {},
            queries,
            window.ssrConfig.routerConfig.short.params
          );
        }
        console.log('search',search)
        console.log('queries',queries)
        return queries;
      } catch (err) {
        console.log("整理参数失败: ", err);
        return {};
      }
    },
    wxClick() {
     
    },
    launchSuccess() {
    },
    launchError() {
      this.goApp();
    },
    checkMasking(callback) {
      this.isShowMasking = !!(this.isWechat || this.isDingTalk || this.isQQ);
      typeof callback === "function" && callback(!this.isShowMasking);
    },
    goApp(sign) {
      this.checkMasking(isOpenClick => {
        if (isOpenClick) {
          this.btnActive = true;
          this.$nextTick(() => {
            const __timeout = setTimeout(() => {
              clearTimeout(__timeout);
              this.btnActive = false;
              this.$nextTick(() => {
                this.goRoutePath(sign);
              });
            }, 100);
          });
        }
      });
    },
    goRoutePath(sign) {
      this.setSign(sign)
      let fromId = this.locationQuery.fromId || '';
      const __timeout = setTimeout(() => {
        clearTimeout(__timeout);
        this.$nextTick(() => {
          if (process.env.NODE_ENV === "development") {
            window.location.href = `/wownow/down-loading/index?fromId=${fromId}&routePath=${encodeURIComponent(this.wxGoAppRouter)}`;
          }
          window.location.href = `/mobile-h5/wownow/down-loading?fromId=${fromId}&routePath=${encodeURIComponent(this.wxGoAppRouter)}`;
        });
      }, 1000);
      
      window.location.href = `${this.appRoutePath}`;
    }
  }
};
